module.exports = __webpack_public_path__ + "static/img/02.b25858e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-assetsM/02.jpg
// module id = WKmN
// module chunks = 1